export default __webpack_public_path__ + "static/media/CNo.20-2.f12435cd.jpg";